<template>
  <div class="col-9">
    <div class="px-4 text-center my-4 border-bottom">
      <h5 class="fw-bold">მომხმარებლის პარამეტრები</h5>
      <p class="text-secondary small mb-4">
        შეცვალეთ ინფორმაცია თქვენს შესახებ
      </p>
    </div>
    <div class="w-75 mx-auto mb-5">
      <form @submit.prevent="handleSubmit" novalidate>
        <div class="mb-3">
          <label class="form-label fw-bold">სახელი</label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': firstnameError }"
            v-model="firstname"
            @focus="firstnameError = false"
          />
          <div v-if="firstnameError" class="invalid-feedback">
            {{ firstnameErrorMessage }}
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label fw-bold">გვარი</label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': lastnameError }"
            v-model="lastname"
            @focus="lastnameError = false"
          />
          <div v-if="lastnameError" class="invalid-feedback">
            {{ lastnameErrorMessage }}
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label fw-bold">სქესი</label>
          <select
            class="form-select"
            v-model="gender"
            :class="{ 'is-invalid': genderError }"
            @focus="genderError = false"
          >
            <option selected style="display: none"></option>
            <option :selected="gender" value="მდედრობითი">მდედრობითი</option>
            <option :selected="gender" value="მამრობითი">მამრობითი</option>
            <option :selected="gender" value="სხვა">სხვა</option>
          </select>
          <div v-if="genderError" class="invalid-feedback">
            {{ genderErrorMessage }}
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label fw-bold">ასაკი</label>
          <select
            class="form-select"
            v-model="age"
            :class="{ 'is-invalid': ageError }"
            @focus="ageError = false"
          >
            <option selected style="display: none"></option>
            <option :selected="age" value="18 წლამდე">18 წლამდე</option>
            <option :selected="age" value="18-24">18-24</option>
            <option :selected="age" value="25-44">25-44</option>
            <option :selected="age" value="45-60">45-60</option>
            <option :selected="age" value="60">60 ></option>
          </select>
          <div v-if="ageError" class="invalid-feedback">
            {{ ageErrorMessage }}
          </div>
        </div>
        <div class="mb-4">
          <label class="form-label fw-bold">ორგანიზაცია</label>
          <select
            class="form-select"
            v-model="organisation"
            :class="{ 'is-invalid': organisationError }"
            @focus="organisationError = false"
          >
            <option selected style="display: none"></option>
            <option :selected="organisation" value="სამთავრობო">
              სამთავრობო
            </option>
            <option :selected="organisation" value="არასამთავრობო">
              არასამთავრობო
            </option>
            <option :selected="organisation" value="კერძო სექტორი">
              კერძო სექტორი
            </option>
            <option :selected="organisation" value="სხვა">სხვა</option>
          </select>
          <div v-if="organisationError" class="invalid-feedback">
            {{ organisationErrorMessage }}
          </div>
        </div>
        <div
          v-if="serverError"
          class="alert alert-danger mb-3 text-center"
          role="alert"
        >
          {{ serverErrorMessage }}
        </div>
        <div
          v-if="serverSuccess"
          class="alert alert-success mb-3 text-center"
          role="alert"
        >
          {{ serverSuccessMessage }}
        </div>
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-primary rounded-pill px-4 font-caps"
          >
            შენახვა
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";

export default {
  props: ["user", "store"],
  setup(props) {
    const firstname = ref(null);
    const lastname = ref(null);
    const email = ref(null);
    const gender = ref(null);
    const age = ref(null);
    const organisation = ref(null);

    const firstnameError = ref(false);
    const firstnameErrorMessage = ref("");
    const lastnameError = ref(false);
    const lastnameErrorMessage = ref("");
    const genderError = ref(false);
    const genderErrorMessage = ref("");
    const ageError = ref(false);
    const ageErrorMessage = ref("");
    const organisationError = ref(false);
    const organisationErrorMessage = ref("");
    const serverError = ref(false);
    const serverErrorMessage = ref("");
    const serverSuccess = ref(false);
    const serverSuccessMessage = ref("");

    firstname.value = props.user.firstname;
    lastname.value = props.user.lastname;
    gender.value = props.user.gender;
    age.value = props.user.age;
    organisation.value = props.user.organisation;
    email.value = props.user.email;

    const handleSubmit = async () => {
      serverSuccess.value = false;
      serverError.value = false;

      if (firstname.value.length === 0) {
        firstnameError.value = true;
        firstnameErrorMessage.value = "სახელის ველი ცარიელია";
      }

      if (lastname.value.length === 0) {
        lastnameError.value = true;
        lastnameErrorMessage.value = "გვარის ველი ცარიელია";
      }

      if (gender.value.length === 0) {
        genderError.value = true;
        genderErrorMessage.value = "მიუთითეთ სქესი";
      }

      if (age.value.length === 0) {
        ageError.value = true;
        ageErrorMessage.value = "მიუთითეთ ასაკი";
      }

      if (organisation.value.length === 0) {
        organisationError.value = true;
        organisationErrorMessage.value = "მიუთითეთ ორგანიზაცია";
      }

      if (
        !firstnameError.value &&
        !lastnameError.value &&
        !genderError.value &&
        !ageError.value &&
        !organisationError.value
      ) {
        try {
          await props.store.dispatch("updateUser", {
            firstname: firstname.value,
            lastname: lastname.value,
            gender: gender.value,
            age: age.value,
            organisation: organisation.value,
          });

          serverSuccess.value = true;
          serverSuccessMessage.value = "პროფილი განახლდა";
        } catch (error) {
          serverError.value = true;
          serverErrorMessage.value = error.message;
        }
      } else {
        serverError.value = false;
      }
    };

    // onMounted(() => {
    //   console.log("onMOunted");
    //   setTimeout(() => {
    //     window.scrollTo({ top: 0, behavior: "smooth" });
    //   }, 1000);
    // });

    return {
      firstname,
      lastname,
      gender,
      age,
      organisation,
      email,
      handleSubmit,
      firstnameError,
      firstnameErrorMessage,
      lastnameError,
      lastnameErrorMessage,
      genderError,
      genderErrorMessage,
      ageError,
      ageErrorMessage,
      organisationError,
      organisationErrorMessage,
      serverError,
      serverErrorMessage,
      serverSuccess,
      serverSuccessMessage,
    };
  },
};
</script>

<style>
</style>